export const numericSortingFn = (rowA, rowB, columnId) => {
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    return (a ?? 0) - (b ?? 0); // Defaulting null/undefined values to 0 for sorting
  };